import {
  VolumeDown as VolumeDownIcon,
  VolumeMute as VolumeMuteIcon,
  VolumeUp as VolumeUpIcon,
} from '@mui/icons-material';
import { IconButton, IconButtonProps } from '@mui/material';
import { useEffect, useRef } from 'react';
import './styles.css';

export interface VolumeSetProps {
  readonly color?: IconButtonProps['color'];
  readonly value: number;
  readonly onChange: (value: number) => void;
  readonly mobile?: boolean;
  readonly sx?: IconButtonProps['sx'];
}

VolumeSet.defaultProps = {
  color: 'secondary',
};

/**
 * Mute toggle with an optional hover volume slider.
 */
export function VolumeSet(p: VolumeSetProps) {
  const prevVolume = useRef<number>();

  useEffect(() => {
    if (p.value > 0) {
      prevVolume.current = p.value;
    }
  });

  const onBtnClick = () => {
    if (p.value > 0) {
      p.onChange(0);
    } else {
      p.onChange(prevVolume.current || 50);
    }
  };

  return (
    <span className="mi-ui-volume-set-volume">
      <IconButton color={p.color} onClick={onBtnClick} sx={p.sx}>
        {p.value === 0 ? <VolumeMuteIcon /> : p.value > 80 ? <VolumeUpIcon /> : <VolumeDownIcon />}
      </IconButton>
      {!p.mobile && (
        <span className="mi-ui-volume-set-volumeInput">
          <input
            value={p.value}
            onChange={(evt) => {
              p.onChange(Number(evt.target.value));
            }}
            type="range"
            min="0"
            step="5"
            max="100"
          />
          <VolumeUpIcon />
        </span>
      )}
    </span>
  );
}
